import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status", "confirmation", "checkbox"]

  connect() {
    this.update()
  }

  update() {
    const shouldConfirm = this.statusTarget.value === "success"

    this.confirmationTarget.classList.toggle("d-none", !shouldConfirm)
    this.checkboxTarget.required = shouldConfirm

    if (!shouldConfirm) {
      this.checkboxTarget.checked = false
    }
  }
}
